/* fiveaven, diagnostic de peau : moteur (implementation de reference du 06/10/2026, textes inchanges, + selection produits) */
(function () {
"use strict";
/*
 * fiveaven, diagnostic de peau : implémentation de référence (6 octobre 2026)
 * Accompagne la note « FIVEAVEN - Note code de peau et préconisations du diagnostic - 06102026 ».
 * Les textes ci-dessous sont les textes définitifs : ne pas les modifier sans l'accord de fiveaven.
 *
 * Réponses attendues (objet `r`) :
 *   principale  : clé de précision (voir PRECISIONS), obligatoire, ex. "bout_c" ou "rien"
 *   secondaire  : clé de précision ou null (jamais la même préoccupation que la principale ; null si principale = "rien")
 *   typePeau    : "grasse" | "mixte" | "normale" | "seche" | "nsp"
 *   reactivite  : "souvent" | "parfois" | "non"
 *   enceinte    : true | false (utilisé pour l'affichage uniquement, JAMAIS enregistré)
 */

const PRECISIONS = {
  "eclat": {
    "preoccupation": "Teint terne",
    "precision": "Teint terne, manque d'éclat",
    "libelleCourt": "un teint terne",
    "bandeau": "Teint terne",
    "titrePreco02": "Ton teint terne"
  },
  "hydra_a": {
    "preoccupation": "Tiraillements",
    "precision": "Ça tiraille (déshydratation)",
    "libelleCourt": "une peau qui tiraille",
    "bandeau": "Peau qui tiraille",
    "titrePreco02": "Ta peau qui tiraille"
  },
  "hydra_b": {
    "preoccupation": "Tiraillements",
    "precision": "Ça pèle, c'est rêche (sécheresse)",
    "libelleCourt": "une peau qui pèle",
    "bandeau": "Peau qui pèle",
    "titrePreco02": "Ta peau qui pèle"
  },
  "roug_a": {
    "preoccupation": "Rougeurs",
    "precision": "Peau réactive",
    "libelleCourt": "une peau réactive",
    "bandeau": "Peau réactive",
    "titrePreco02": "Ta peau réactive"
  },
  "roug_b": {
    "preoccupation": "Rougeurs",
    "precision": "Barrière récemment fragilisée",
    "libelleCourt": "une barrière fragilisée",
    "bandeau": "Barrière fragilisée",
    "titrePreco02": "Ta barrière fragilisée"
  },
  "roug_c": {
    "preoccupation": "Rougeurs",
    "precision": "Rosacée ou couperose diagnostiquée",
    "libelleCourt": "une rosacée ou une couperose",
    "bandeau": "Rosacée ou couperose",
    "titrePreco02": "Ta rosacée ou ta couperose"
  },
  "bout_a": {
    "preoccupation": "Boutons",
    "precision": "Points noirs, comédons",
    "libelleCourt": "des points noirs",
    "bandeau": "Points noirs",
    "titrePreco02": "Tes points noirs"
  },
  "bout_b": {
    "preoccupation": "Boutons",
    "precision": "Boutons rouges inflammés",
    "libelleCourt": "des boutons inflammés",
    "bandeau": "Boutons inflammés",
    "titrePreco02": "Tes boutons inflammés"
  },
  "bout_c": {
    "preoccupation": "Boutons",
    "precision": "Acné régulière ou persistante",
    "libelleCourt": "une acné régulière",
    "bandeau": "Acné régulière",
    "titrePreco02": "Ton acné régulière"
  },
  "pores_a": {
    "preoccupation": "Pores",
    "precision": "Pores visibles et brillance",
    "libelleCourt": "des pores visibles et de la brillance",
    "bandeau": "Pores et brillance",
    "titrePreco02": "Tes pores et la brillance"
  },
  "pores_b": {
    "preoccupation": "Pores",
    "precision": "Grain rêche et irrégulier",
    "libelleCourt": "un grain de peau irrégulier",
    "bandeau": "Grain irrégulier",
    "titrePreco02": "Ton grain de peau"
  },
  "tach_a": {
    "preoccupation": "Taches",
    "precision": "Taches liées au soleil",
    "libelleCourt": "des taches de soleil",
    "bandeau": "Taches de soleil",
    "titrePreco02": "Tes taches de soleil"
  },
  "tach_b": {
    "preoccupation": "Taches",
    "precision": "Marques post-bouton",
    "libelleCourt": "des marques post-bouton",
    "bandeau": "Marques post-bouton",
    "titrePreco02": "Tes marques post-bouton"
  },
  "tach_c": {
    "preoccupation": "Taches",
    "precision": "Taches en plaques (mélasma)",
    "libelleCourt": "des taches en plaques",
    "bandeau": "Taches en plaques",
    "titrePreco02": "Tes taches en plaques"
  },
  "rides_a": {
    "preoccupation": "Rides",
    "precision": "Prévention douce (ridules)",
    "libelleCourt": "des ridules",
    "bandeau": "Ridules",
    "titrePreco02": "Tes ridules"
  },
  "rides_b": {
    "preoccupation": "Rides",
    "precision": "Action marquée (rides installées)",
    "libelleCourt": "des rides installées",
    "bandeau": "Rides installées",
    "titrePreco02": "Tes rides installées"
  },
  "cernes": {
    "preoccupation": "Cernes",
    "precision": "Cernes, poches",
    "libelleCourt": "des cernes ou des poches",
    "bandeau": "Cernes ou poches",
    "titrePreco02": "Tes cernes et tes poches"
  },
  "rien": {
    "preoccupation": "Rien",
    "precision": "Rien de particulier",
    "libelleCourt": null,
    "bandeau": null,
    "titrePreco02": "L'entretien de ta peau"
  }
};

const POINTS_BARRIERE = {
  "roug_a": 2,
  "roug_b": 3,
  "roug_c": 3,
  "hydra_a": 1,
  "hydra_b": 2
};

const POINTS_REACTIVITE = {
  "souvent": 3,
  "parfois": 1,
  "non": 0
};

const DERMIQUE = [
  "cernes",
  "rides_a",
  "rides_b",
  "roug_c",
  "tach_c"
];

const POINTS_TYPE_PEAU = {
  "grasse": 2,
  "mixte": 1,
  "normale": 0,
  "nsp": 0,
  "seche": -1
};

const POINTS_SEBUM = {
  "bout_a": 1,
  "bout_b": 1,
  "bout_c": 1,
  "pores_a": 1,
  "hydra_b": -1
};

const LIBELLES_NIVEAUX = {
  "barriere": {
    "I": "intacte",
    "S": "sollicitée",
    "F": "fragilisée",
    "R": "réactive"
  },
  "profondeur": {
    "E": "épidermique",
    "D": "dermique"
  },
  "sebum": {
    "−": "faible",
    "=": "modérée",
    "+": "élevée"
  }
};

const CURSEURS = {
  "barriere": {
    "titre": "Fonction barrière",
    "positions": [
      "Intacte",
      "Sollicitée",
      "Fragilisée",
      "Réactive"
    ],
    "texte": "La couche la plus superficielle de ta peau retient l'eau et filtre ce qui vient de l'extérieur. Quand elle est sollicitée, l'eau s'évapore plus vite (ce que les dermatologues appellent la perte insensible en eau) et la peau tiraille ou réagit. Indiquée par la première lettre de ton code."
  },
  "profondeur": {
    "titre": "Profondeur cutanée",
    "positions": [
      "Épidermique",
      "Dermique"
    ],
    "texte": "Indique la couche de la peau où se joue ta préoccupation principale : en surface, dans l'épiderme (grain, éclat, imperfections), ou plus en profondeur, dans le derme, où se trouvent le collagène et les petits vaisseaux. Indiquée par la deuxième lettre de ton code."
  },
  "sebum": {
    "titre": "Activité sébacée",
    "positions": [
      "Hyposéborrhée",
      "Séborrhée modérée",
      "Hyperséborrhée"
    ],
    "texte": "Les glandes sébacées produisent le sébum, un film gras qui protège et assouplit la peau. En excès, il fait briller et obstrue les pores ; en manque, la peau s'assèche. Indiquée par le symbole de ton code."
  }
};

const PRECO01 = {
  "I": "Ta barrière cutanée est intacte : ta peau retient bien son eau et tolère la plupart des textures. Garde un nettoyage doux et une crème adaptée à la saison, inutile d'en faire plus.",
  "S": "Ta barrière est sollicitée : elle laisse filer un peu plus d'eau qu'elle ne devrait. Privilégie un nettoyant au pH doux, applique ton hydratation sur peau encore humide et limite les exfoliants à une ou deux fois par semaine.",
  "F": "Ta barrière est fragilisée : la peau perd son eau plus vite et réagit plus facilement. Réduis le nombre de produits, choisis des formules apaisantes (centella, panthénol, céramides), introduis un seul nouveau produit à la fois et mets les exfoliants de côté le temps qu'elle se rééquilibre.",
  "R": "Ta barrière est réactive : picotements et rougeurs arrivent vite. Reste sur une routine courte (nettoyant doux, sérum apaisant, crème barrière, protection solaire), teste chaque nouveau produit quelques jours sur une petite zone et évite parfums et exfoliants.",
  "E": "Ta préoccupation se joue en surface, dans l'épiderme, la couche qui se renouvelle le plus vite (environ quatre semaines) : c'est sur cette durée qu'il faut juger une routine.",
  "D": "Ta préoccupation se joue plus en profondeur, dans le derme, où se trouvent le collagène et les petits vaisseaux. Les changements y sont plus lents : compte au moins deux à trois mois de régularité, et protège ta peau du soleil chaque jour, c'est ce qui préserve le mieux le derme.",
  "−": "Ta peau produit peu de sébum et son film protecteur est mince : choisis des nettoyants sans savon, des textures riches ou une huile le soir, et ne laisse jamais ta peau sans crème.",
  "=": "Ta production de sébum est modérée : garde des textures légères à moyennes et ajuste selon la saison, plus riches en hiver, plus fraîches en été.",
  "+": "Ta peau produit beaucoup de sébum : elle brille vite et ses pores s'obstruent plus facilement. Préfère des textures fluides ou en gel, non comédogènes, et continue d'hydrater : les soins trop asséchants n'en réduisent pas la production et fragilisent la peau."
};

const PRECO02 = {
  "eclat": {
    "base": "Un teint terne vient souvent de cellules mortes qui s'accumulent en surface et d'un manque d'hydratation. Un soin hydratant chaque jour et une protection solaire le matin redonnent de la lumière.",
    "standard": "Une exfoliation douce (enzymes, acides de fruits) une à deux fois par semaine et un sérum à la vitamine C le matin aident à unifier.",
    "douce": "Un masque hydratant une à deux fois par semaine aide à raviver l'éclat.",
    "regle": "FR"
  },
  "hydra_a": {
    "base": "Ta peau manque d'eau, pas forcément de gras : elle tiraille, surtout après le nettoyage. Superpose des couches fines (lotion, essence, sérum hydratant à l'acide hyaluronique ou au riz) sur peau encore humide, puis termine par une crème légère. Évite les nettoyants qui moussent beaucoup et l'eau trop chaude.",
    "standard": null,
    "douce": null,
    "regle": null
  },
  "hydra_b": {
    "base": "Ta peau manque de lipides : elle pèle et reste rêche. Choisis un nettoyant crème ou une huile, puis une crème riche (céramides, beurres végétaux) matin et soir ; le soir, un masque de nuit renforce le film protecteur. Laisse les exfoliants de côté tant que la peau pèle.",
    "standard": null,
    "douce": null,
    "regle": null
  },
  "roug_a": {
    "base": "Ta peau réagit vite aux produits, au froid ou à la chaleur. Garde une routine courte et stable, introduis un seul nouveau produit à la fois et teste-le quelques jours sur une petite zone. Les actifs apaisants (centella, heartleaf, panthénol) et une protection solaire quotidienne t'aident à la garder calme.",
    "standard": null,
    "douce": null,
    "regle": null
  },
  "roug_b": {
    "base": "Après un coup de soleil, un peeling ou un laser, la peau a besoin de temps pour reconstruire sa barrière. Pendant deux à quatre semaines, mets de côté exfoliants, rétinol et parfums, applique une crème réparatrice matin et soir et protège-toi du soleil sans exception. Si la gêne persiste, parles-en à ton dermatologue.",
    "standard": null,
    "douce": null,
    "regle": null
  },
  "roug_c": {
    "base": "La rosacée et la couperose se vivent mieux en limitant ce qui dilate les petits vaisseaux : chaleur, eau très chaude, gommages, alcool dans les soins. Une routine minimale aux actifs apaisants et une protection solaire chaque jour aident la peau à rester calme. Ta sélection vient en complément du suivi de ton dermatologue.",
    "standard": null,
    "douce": null,
    "regle": null
  },
  "bout_a": {
    "base": "Les points noirs sont des pores obstrués par du sébum qui noircit à l'air. Le soir, fais un double nettoyage (une huile, puis un nettoyant doux) et ne presse pas les points noirs : tu risques d'irriter la peau et de dilater le pore.",
    "standard": "Un exfoliant au BHA (acide salicylique) agit à l'intérieur du pore pour le désobstruer : commence par une à deux fois par semaine, puis jusqu'à trois selon la tolérance.",
    "douce": "Un masque à l'argile une à deux fois par semaine aide à désobstruer les pores en douceur.",
    "regle": "FR"
  },
  "bout_b": {
    "base": "Les boutons rouges sont des pores obstrués où une inflammation s'est installée. Nettoie matin et soir avec un nettoyant doux, protège les boutons avec un patch et ne les perce pas, pour éviter les marques.",
    "standard": "Le soir, un soin au BHA ou à l'arbre à thé aide à assainir la peau : commence par une à deux fois par semaine, puis jusqu'à trois selon la tolérance.",
    "douce": "Le soir, un soin apaisant à la centella ou à l'arbre à thé aide à calmer la peau.",
    "regle": "FR"
  },
  "bout_c": {
    "base": "Quand les boutons reviennent souvent, les pores s'obstruent en continu sous l'effet d'un sébum abondant. Mise sur la régularité : un nettoyant doux matin et soir, une hydratation qui ne graisse pas, un patch sur les boutons les plus marqués, et ne les perce pas pour éviter les marques. Si les boutons persistent ou laissent des cicatrices, un dermatologue peut t'accompagner.",
    "standard": "Le soir, un actif purifiant (BHA, arbre à thé) aide à garder les pores dégagés : commence par une à deux fois par semaine, puis jusqu'à trois selon la tolérance.",
    "douce": "Le soir, un actif purifiant doux comme l'arbre à thé aide à garder les pores dégagés.",
    "regle": "FR"
  },
  "pores_a": {
    "base": "Les pores paraissent plus grands quand le sébum les remplit et que la peau brille. Un double nettoyage le soir, une texture légère non comédogène et un masque à l'argile une fois par semaine aident à les rendre moins visibles.",
    "standard": "Un tonique au BHA les désobstrue : commence par une à deux fois par semaine, puis jusqu'à trois selon la tolérance.",
    "douce": "",
    "regle": "FR"
  },
  "pores_b": {
    "base": "Un grain irrégulier vient de cellules mortes qui s'accumulent quand le renouvellement de la peau ralentit. Une hydratation soutenue aide à lisser la surface au fil des semaines.",
    "standard": "Alterne un exfoliant aux AHA et des pads exfoliants : commence par une à deux fois par semaine, puis jusqu'à trois selon la tolérance.",
    "douce": "Préfère des pads de nuit doux, sans exfoliant acide.",
    "regle": "FR"
  },
  "tach_a": {
    "base": "Les taches solaires apparaissent là où la peau a reçu le plus de soleil au fil des années. Le geste le plus important est une protection solaire SPF 50 chaque matin, toute l'année, renouvelée en cas d'exposition.",
    "standard": "Le soir, un sérum à la niacinamide ou à l'acide tranexamique et une exfoliation douce aident à unifier le teint.",
    "douce": "La protection solaire reste le geste principal ; les soins à la niacinamide ou à la vitamine C restent possibles, les actifs plus puissants attendront.",
    "regle": "FR"
  },
  "tach_b": {
    "base": "La plupart des marques brunes laissées par les boutons s'estompent avec le temps ; les marques en creux sont des cicatrices et relèvent d'un dermatologue. Ne touche pas aux boutons pour ne pas en créer de nouvelles et protège ta peau du soleil chaque jour, car il fonce les marques.",
    "standard": "Le soir, un soin unifiant (acide tranexamique, niacinamide) aide à les atténuer.",
    "douce": "La protection solaire reste le geste principal ; les soins à la niacinamide ou à la vitamine C restent possibles, les actifs plus puissants attendront.",
    "regle": "G"
  },
  "tach_c": {
    "base": "Le mélasma forme des plaques brunes, souvent liées aux hormones et ravivées par la chaleur et la lumière, y compris la lumière visible. Une protection solaire teintée SPF 50, dont les oxydes de fer filtrent aussi cette lumière, est indispensable chaque jour et se renouvelle dans la journée ; évite aussi les sources de chaleur intense. Si les plaques s'étendent, un dermatologue peut t'accompagner.",
    "standard": "Le soir, un soin à l'acide tranexamique aide à unifier le teint.",
    "douce": "La protection solaire teintée reste le geste clé ; les actifs plus puissants attendront. Le mélasma lié à une grossesse s'atténue souvent après l'accouchement.",
    "regle": "G"
  },
  "rides_a": {
    "base": "Les ridules apparaissent quand la peau perd un peu d'eau et de souplesse. Une hydratation régulière, un contour des yeux et surtout une protection solaire quotidienne sont la meilleure prévention, le soleil étant la principale cause du vieillissement visible de la peau. Le soir, un sérum aux peptides entretient la fermeté.",
    "standard": null,
    "douce": null,
    "regle": null
  },
  "rides_b": {
    "base": "Les rides installées traduisent un relâchement du collagène et de l'élastine dans le derme. Les gestes qui comptent : un soin riche en peptides, une crème nourrissante, des patchs pour le contour des yeux et une protection solaire chaque matin. Compte deux à trois mois de régularité avant de juger.",
    "standard": "Une à deux fois par semaine, un soin à micro-pointes (roller) peut compléter la routine, avec un outil propre et jamais sur des boutons, une rosacée ou une peau irritée.",
    "douce": "Mieux vaut s'en tenir à une crème aux peptides et à une protection solaire quotidienne, sans roller à micro-pointes.",
    "regle": "FR"
  },
  "cernes": {
    "base": "Les cernes et les poches viennent de la finesse de la peau à cet endroit, de la circulation et du manque de sommeil. Applique un contour des yeux en tapotant, du coin interne vers l'extérieur, et utilise des patchs le matin pour défroisser le regard ; un contour gardé au frais renforce l'effet décongestionnant.",
    "standard": null,
    "douce": null,
    "regle": null
  },
  "rien": {
    "base": "Tu n'as pas signalé de préoccupation particulière : l'objectif est d'entretenir ta peau. Un nettoyage doux, une hydratation adaptée à la saison et une protection solaire chaque matin suffisent, avec un masque de temps en temps pour le plaisir.",
    "standard": null,
    "douce": null,
    "regle": null
  }
};

const PRECO03 = {
  "Teint terne": "Le sommeil et l'arrêt du tabac comptent autant que les soins pour l'éclat. La riboflavine, présente dans les œufs, les amandes et les champignons, contribue au maintien d'une peau normale.",
  "Tiraillements": "L'air sec des pièces chauffées et les douches longues et très chaudes accentuent les tiraillements. La biotine, présente dans les œufs, les fruits à coque et les légumineuses, contribue au maintien d'une peau normale.",
  "Rougeurs": "Chaleur, sauna, boissons très chaudes, alcool et plats épicés sont les déclencheurs les plus fréquents : repère ceux qui te concernent. Le stress en fait partie, quelques minutes de pause par jour comptent.",
  "Boutons": "Une alimentation à index glycémique bas, avec moins de sucres rapides, peut aider à limiter les poussées. Le zinc, présent dans les fruits de mer, la viande et les graines de courge, contribue au maintien d'une peau normale.",
  "Pores": "Nettoie ta peau chaque soir, même sans maquillage : écran solaire, sébum et pollution s'accumulent dans les pores. La niacine (vitamine B3), présente dans la volaille, le poisson et les céréales complètes, contribue au maintien d'une peau normale.",
  "Taches": "Un chapeau à larges bords et l'ombre aux heures chaudes complètent la protection solaire. Les fruits et légumes colorés, riches en vitamine C, ont aussi leur place dans l'assiette.",
  "Rides": "Le tabac et le soleil sont les deux grands accélérateurs du vieillissement visible, et un sommeil suffisant aide la peau à se réparer. La vitamine C, présente dans les agrumes, le kiwi et le poivron, contribue à la formation normale de collagène pour assurer la fonction normale de la peau.",
  "Cernes": "Le manque de sommeil, l'alcool et le sel en excès marquent le regard ; dormir la tête légèrement surélevée limite les poches du matin.",
  "Rien": "Un sommeil régulier, une alimentation variée riche en fruits et légumes et le tabac tenu à distance restent les meilleurs alliés de ta peau."
};

const PRECO03_MENTION = "Ces conseils ne remplacent pas une alimentation variée et équilibrée et un mode de vie sain.";

const PRECO03_GROSSESSE = "Pendant la grossesse ou l'allaitement, demande l'avis de ton médecin ou de ta sage-femme avant tout complément alimentaire.";

const FIN_SELECTION = "Ta sélection est conçue pour évoluer selon les produits en stock et intègre les nouveautés au fur et à mesure, afin de correspondre au mieux à ton code.";

const PART_ESTIMEE = {
  "IEm": 0.024422,
  "IEn": 0.097002,
  "IEp": 0.038091,
  "IDm": 0.016172,
  "IDn": 0.046108,
  "IDp": 0.014728,
  "SEm": 0.070237,
  "SEn": 0.2106,
  "SEp": 0.076446,
  "SDm": 0.034067,
  "SDn": 0.083021,
  "SDp": 0.025315,
  "FEm": 0.043565,
  "FEn": 0.091729,
  "FEp": 0.029142,
  "FDm": 0.015599,
  "FDn": 0.040873,
  "FDp": 0.012669,
  "REm": 0.008601,
  "REn": 0.011198,
  "REp": 0.00267,
  "RDm": 0.002099,
  "RDn": 0.004389,
  "RDp": 0.001256
};

const MOINS = "\u2212"; // vrai signe moins pour l'affichage
const ASCII = { [MOINS]: "m", "=": "n", "+": "p" };
const DEPUIS_ASCII = { m: MOINS, n: "=", p: "+" };

function preoccupation(cle) { return cle ? PRECISIONS[cle].preoccupation : null; }

/* 1. Calcul du code ------------------------------------------------------- */
function scoreBarriere(r) {
  let s = POINTS_REACTIVITE[r.reactivite];
  s += POINTS_BARRIERE[r.principale] || 0;
  if (r.secondaire && POINTS_BARRIERE[r.secondaire] !== undefined) s += Math.max(POINTS_BARRIERE[r.secondaire] - 1, 1);
  return s;
}
function lettreBarriere(s) { return s === 0 ? "I" : s <= 2 ? "S" : s <= 4 ? "F" : "R"; }
function lettreProfondeur(r) { return DERMIQUE.includes(r.principale) ? "D" : "E"; }
function scoreSebum(r) {
  let s = POINTS_TYPE_PEAU[r.typePeau];
  s += POINTS_SEBUM[r.principale] || 0;
  if (r.secondaire) s += POINTS_SEBUM[r.secondaire] || 0;
  return s;
}
function symboleSebum(s) { return s <= -1 ? MOINS : s <= 1 ? "=" : "+"; }

function verifierReponses(r) {
  if (!PRECISIONS[r.principale]) throw new Error("principale inconnue");
  if (r.secondaire) {
    if (!PRECISIONS[r.secondaire] || r.secondaire === "rien") throw new Error("secondaire inconnue");
    if (r.principale === "rien") throw new Error("pas de secondaire après « rien de particulier »");
    if (preoccupation(r.secondaire) === preoccupation(r.principale)) throw new Error("secondaire = même préoccupation que la principale");
  }
  if (!(r.typePeau in POINTS_TYPE_PEAU) || !(r.reactivite in POINTS_REACTIVITE)) throw new Error("réponse manquante");
}

function calculerCode(r) {
  verifierReponses(r);
  const code = lettreBarriere(scoreBarriere(r)) + lettreProfondeur(r) + symboleSebum(scoreSebum(r));
  return { code, enregistrement: code.slice(0, 2) + ASCII[code[2]] };
}

/* 2. Pourcentages ---------------------------------------------------------
 * compteurs : { "SEp": 12, "IEn": 30, ... } (codes enregistrés, 24 clés au plus) */
const POIDS_ESTIMATION = 50;
const SEUIL_DIAGNOSTICS_REELS = 300;
function totalDiagnostics(compteurs) { return Object.values(compteurs || {}).reduce((a, b) => a + b, 0); }
function partLissee(codeEnregistre, compteurs) {
  const n = (compteurs && compteurs[codeEnregistre]) || 0;
  return (n + POIDS_ESTIMATION * PART_ESTIMEE[codeEnregistre]) / (totalDiagnostics(compteurs) + POIDS_ESTIMATION);
}
function phrasePourcentage(codeEnregistre, compteurs) {
  const x = Math.max(1, Math.round(100 * partLissee(codeEnregistre, compteurs)));
  return totalDiagnostics(compteurs) < SEUIL_DIAGNOSTICS_REELS
    ? `Comme environ ${x}\u00a0% des personnes.`
    : `Comme ${x}\u00a0% des personnes qui ont fait le diagnostic.`;
}
function arrondi100(parts) { // parts : { cle: fraction } -> entiers totalisant 100
  const cles = Object.keys(parts), brut = cles.map(k => 100 * parts[k]);
  const ent = brut.map(Math.floor);
  let reste = 100 - ent.reduce((a, b) => a + b, 0);
  cles.map((k, i) => i).sort((a, b) => (brut[b] - ent[b]) - (brut[a] - ent[a])).slice(0, reste).forEach(i => ent[i]++);
  return Object.fromEntries(cles.map((k, i) => [k, ent[i]]));
}
function partsCurseurs(compteurs) {
  const pos = { barriere: { I: 0, S: 0, F: 0, R: 0 }, profondeur: { E: 0, D: 0 }, sebum: { [MOINS]: 0, "=": 0, "+": 0 } };
  for (const c of Object.keys(PART_ESTIMEE)) {
    const p = partLissee(c, compteurs);
    pos.barriere[c[0]] += p; pos.profondeur[c[1]] += p; pos.sebum[DEPUIS_ASCII[c[2]]] += p;
  }
  return { barriere: arrondi100(pos.barriere), profondeur: arrondi100(pos.profondeur), sebum: arrondi100(pos.sebum) };
}

/* 3. Textes de la page ---------------------------------------------------- */
function phraseSynthese(r) {
  if (r.principale === "rien") return "D'après tes réponses, tu n'as pas signalé de préoccupation particulière.";
  let t = `D'après tes réponses, ta préoccupation principale est ${PRECISIONS[r.principale].libelleCourt}.`;
  if (r.secondaire) t += ` En second\u00a0: ${PRECISIONS[r.secondaire].libelleCourt}.`;
  return t;
}
function bandeau(r, code) {
  const l = LIBELLES_NIVEAUX;
  const out = [`Barrière ${l.barriere[code[0]]}`, `Profondeur ${l.profondeur[code[1]]}`, `Activité sébacée ${l.sebum[code[2]]}`];
  if (r.principale !== "rien") out.push(PRECISIONS[r.principale].bandeau);
  if (r.secondaire) out.push(PRECISIONS[r.secondaire].bandeau);
  return out;
}
function phrasesFinResultats(r) {
  const out = [];
  if (r.principale !== "rien") {
    out.push(r.secondaire
      ? `À ton code s'ajoutent tes préoccupations\u00a0: ${PRECISIONS[r.principale].libelleCourt} en premier, ${PRECISIONS[r.secondaire].libelleCourt} en second.`
      : `À ton code s'ajoute ta préoccupation\u00a0: ${PRECISIONS[r.principale].libelleCourt}.`);
  }
  out.push(FIN_SELECTION);
  return out;
}

/* 4. Préconisations -------------------------------------------------------
 * pageRappelee : true si la page est affichée depuis un diagnostic sauvegardé ou un lien partagé
 * (la réponse grossesse n'étant pas conservée, on affiche alors la version la plus prudente). */
function versionDouce(r, code, pageRappelee) {
  const p = PRECO02[r.principale];
  if (!p.regle) return null;
  return Boolean(pageRappelee || r.enceinte || (p.regle === "FR" && "FR".includes(code[0])));
}
function preconisations(r, { pageRappelee = false } = {}) {
  const { code } = calculerCode(r);
  const p2 = PRECO02[r.principale], douce = versionDouce(r, code, pageRappelee);
  const fin = douce === null ? "" : (douce ? p2.douce : p2.standard);
  const g = PRECISIONS[r.principale].preoccupation;
  const p3 = [PRECO03[g], PRECO03_MENTION];
  if (pageRappelee || r.enceinte) p3.push(PRECO03_GROSSESSE);
  return [
    { numero: "01", titre: `Ton type ${code}`, texte: [PRECO01[code[0]], PRECO01[code[1]], PRECO01[code[2]]].join(" ") },
    { numero: "02", titre: PRECISIONS[r.principale].titrePreco02, texte: [p2.base, fin].filter(Boolean).join(" "), versionDouce: douce },
    { numero: "03", titre: "Au quotidien", texte: p3.join(" ") },
  ];
}

/* 5. Tout ce qu'affiche la page ------------------------------------------ */
function resultat(r, compteurs = {}, options = {}) {
  const { code, enregistrement } = calculerCode(r);
  return {
    code, enregistrement,
    pourcentage: phrasePourcentage(enregistrement, compteurs),
    synthese: phraseSynthese(r),
    bandeau: bandeau(r, code),
    curseurs: { positions: { barriere: code[0], profondeur: code[1], sebum: code[2] }, parts: partsCurseurs(compteurs), textes: CURSEURS },
    finResultats: phrasesFinResultats(r),
    preconisations: preconisations(r, options),
  };
}

/* 6. Cas de test (node « fichier.js ») ------------------------------------ */
function tests() {
  const cas = [
    ["Léa",     { principale: "bout_c",  secondaire: "hydra_a", typePeau: "mixte",   reactivite: "parfois", enceinte: false }, "SE+", false],
    ["Thomas",  { principale: "rides_b", secondaire: "tach_a",  typePeau: "normale", reactivite: "non",     enceinte: false }, "ID=", false],
    ["Camille", { principale: "roug_c",  secondaire: "hydra_b", typePeau: "seche",   reactivite: "souvent", enceinte: false }, "RD" + MOINS, null],
    ["Inès",    { principale: "pores_a", secondaire: null,      typePeau: "grasse",  reactivite: "non",     enceinte: false }, "IE+", false],
    ["Paul",    { principale: "rien",    secondaire: null,      typePeau: "nsp",     reactivite: "parfois", enceinte: false }, "SE=", null],
    ["Hugo",    { principale: "bout_c",  secondaire: null,      typePeau: "seche",   reactivite: "non",     enceinte: false }, "IE=", false],
    ["Sarah",   { principale: "bout_a",  secondaire: null,      typePeau: "grasse",  reactivite: "souvent", enceinte: false }, "FE+", true],
    ["Julie",   { principale: "tach_a",  secondaire: "rides_a", typePeau: "normale", reactivite: "parfois", enceinte: true  }, "SE=", true],
    ["Nora",    { principale: "rien",    secondaire: null,      typePeau: "normale", reactivite: "souvent", enceinte: false }, "FE=", null],
  ];
  for (const [nom, r, attendu, douce] of cas) {
    const res = resultat(r);
    console.assert(res.code === attendu, `${nom} : ${res.code} au lieu de ${attendu}`);
    console.assert(res.preconisations[1].versionDouce === douce, `${nom} : version douce incorrecte`);
  }
  const lea = cas[0][1];
  console.assert(resultat(lea).pourcentage === "Comme environ 8\u00a0% des personnes.", "Léa : pourcentage");
  console.assert(preconisations(lea, { pageRappelee: true })[1].versionDouce === true, "Léa rappelée : version douce");
  const somme = Object.values(PART_ESTIMEE).reduce((a, b) => a + b, 0);
  console.assert(Math.abs(somme - 1) < 1e-4, "parts estimées : total différent de 100 %");
  console.log("Tests terminés.");
}

/* 7. Selection des produits (matrice du 26/09/2026) */
/* ---------------------------------------------------------------------------
 * Selection des produits (matrice fiveaven, onglet « Règles de sélection »).
 * Code ajoute a l'implementation de reference ; les regles 1 a 7 sont suivies
 * dans l'ordre. `dispo(handle)` exclut les produits en rupture (phrase
 * « Ta selection est concue pour evoluer selon les produits en stock »).
 * ------------------------------------------------------------------------- */
const ROLE_PAR_TYPE = {
  "Nettoyant aqueux": "Nettoyant doux", "Nettoyant huileux": "Huile nettoyante", "Nettoyant": "Nettoyant",
  "Sérum": "Sérum", "Ampoule": "Ampoule", "Essence": "Essence", "Crème": "Crème", "Toner": "Lotion tonique",
  "Pads": "Pads", "Masque tissu": "Masque tissu", "Masque gel": "Masque gel", "Masque crémeux": "Masque",
  "SPF": "Protection solaire", "Crème contour des yeux": "Contour des yeux", "Patchs yeux": "Patchs yeux",
  "Patch boutons": "Patchs boutons", "Capsules": "Capsules", "Mist": "Brume", "Exfoliant chimique": "Exfoliant",
  "Exfoliant mécanique": "Exfoliant"
};
function scenarioVeto(r) { return (r.enceinte ? "e" : "p") + (r.reactivite === "souvent" ? "s" : "n"); }
function rang(liste, alea) { // regle 5 : « Oui +++ », puis desirabilite, puis tirage
  return liste.map(p => ({ p, a: alea() }))
    .sort((x, y) => (y.p.v - x.p.v) || (y.p.d - x.p.d) || (x.a - y.a)).map(x => x.p);
}
const COMPO = ["nettoyant_aqueux", "serum", "creme"];
const EST_NETTOYANT_OU_CREME = p => p.f === "nettoyant" || p.f === "nettoyant_aqueux" || p.f === "creme";
/* 23/10/2026 (Andy) : jamais deux produits de la même catégorie dans une sélection ; sérum et ampoule comptent ensemble,
   les masques (tissu, gel, crémeux) aussi, de même que les exfoliants ; nettoyant huileux et aqueux restent distincts (double nettoyage) */
const CATEGORIE = p => { const t = String(p.t || ""); if (t === "Sérum" || t === "Ampoule") return "serum"; if (/^Masque/.test(t)) return "masque";
  if (/^Exfoliant/.test(t)) return "exfoliant"; if (t === "Nettoyant") return "Nettoyant aqueux"; return t || p.f || p.h; };

function selectionProduits(r, donnees, dispo, alea = Math.random) {
  const sc = scenarioVeto(r);
  const tableau = cle => ((donnees.tables[cle] || {})[sc] || []).filter(p => dispo(p.h));
  const choisis = [], pris = new Set(), cats = new Set();
  /* 28/10/2026 (Andy) : une seule source d'exfoliation par sélection (acides AHA/BHA/PHA, enzymes, gommage, spicules, rétinol ;
     liste et raisons dans donnees.exfoliants) : deux de ces produits dans la même routine fragilisent la barrière cutanée.
     Le premier exfoliant retenu par les règles habituelles (préoccupation principale d'abord, puis règle 5) reste ; les suivants
     sont refusés et leur place revient au produit suivant du tableau */
  const EXF = p => !!(donnees.exfoliants && donnees.exfoliants[p.h]);
  const libre = p => !pris.has(p.h) && !cats.has(CATEGORIE(p)) && !(EXF(p) && choisis.some(EXF));
  const prendre = (p, origine) => { if (!libre(p)) return false; choisis.push(Object.assign({}, p, { origine, role: ROLE_PAR_TYPE[p.t] || p.t })); pris.add(p.h); cats.add(CATEGORIE(p)); return true; };
  const premier = (liste, critere) => rang(liste.filter(p => libre(p) && critere(p)), alea)[0];

  /* Regle 7 : rien de particulier -> tirage dans tout le catalogue compatible avec les vetos */
  if (r.principale === "rien") {
    const pool = donnees.catalogue.filter(p => dispo(p.h) && (!r.enceinte || p.e) && (r.reactivite !== "souvent" || p.s));
    const tire = crit => { const c = pool.filter(p => libre(p) && crit(p)); return c.length ? c[Math.floor(alea() * c.length)] : null; };
    for (const fam of COMPO) { const p = tire(x => x.f === fam); if (p) prendre(p, "principale"); }
    for (let i = 0; i < 2; i++) { const p = tire(x => !EST_NETTOYANT_OU_CREME(x)); if (p) prendre(p, "principale"); }
    return { produits: choisis, vide: !choisis.length };
  }

  const T1 = tableau(r.principale), T2 = r.secondaire ? tableau(r.secondaire) : [];
  if (!T1.length && !T2.length) return { produits: [], vide: true };   // ex. taches + grossesse : ecran dedie
  const placesP = r.secondaire ? 3 : 5;
  let emprunts = 0;

  /* Regle 3 : tableau entier si il tient dans les places, sans arbitrage */
  if (T1.length <= placesP) {
    for (const fam of COMPO) rang(T1.filter(p => p.f === fam), alea).forEach(p => prendre(p, "principale"));   // prendre() écarte les doublons de catégorie
    rang(T1, alea).forEach(p => prendre(p, "principale"));
  } else {
    /* Regle 4 + 6 : nettoyant aqueux, serum, creme ; a defaut cherches dans le tableau secondaire */
    for (const fam of COMPO) {
      let p = premier(T1, x => x.f === fam);
      if (p) { prendre(p, "principale"); continue; }
      if (T2.length) { p = premier(T2, x => x.f === fam); if (p) { prendre(p, "garantie"); emprunts++; continue; } }
      if (fam === "nettoyant_aqueux") {   // nettoyant universel MIDHA
        const u = donnees.catalogue.find(x => x.h === donnees.nettoyantUniversel);
        if (u && dispo(u.h)) prendre(u, "principale");
      }
    }
    /* places restantes de la principale : jamais un second nettoyant ni une seconde creme, puis regle 5 */
    while (choisis.filter(p => p.origine === "principale").length < placesP) {
      const p = premier(T1, x => !EST_NETTOYANT_OU_CREME(x)) || premier(T1, () => true);
      if (!p) break; prendre(p, "principale");
    }
  }
  /* Preoccupation secondaire : 2 produits complementaires, jamais nettoyant ni creme (contour des yeux admis) */
  if (r.secondaire) {
    const placesS = Math.max(0, 2 - emprunts);
    const cand = T2.filter(p => !EST_NETTOYANT_OU_CREME(p));
    for (let i = 0; i < placesS; i++) { const p = premier(cand, () => true); if (!p) break; prendre(p, "secondaire"); }
  }
  /* 23/10/2026 : places laissées vides par la règle « une seule fois par catégorie » : complétées dans le tableau secondaire,
     puis dans le principal (toujours sans doublon de catégorie) */
  if (choisis.length) for (const p of rang(T2, alea).concat(rang(T1, alea))) { if (choisis.length >= 5) break; prendre(p, T2.includes(p) ? "secondaire" : "principale"); }
  return { produits: choisis.slice(0, 5), vide: !choisis.length };
}

window.FVDiag = { calculerCode, resultat, preconisations, phrasePourcentage, partsCurseurs, selectionProduits, PRECISIONS, PART_ESTIMEE, tests };
})();
